import { createFileRoute, Outlet } from "@tanstack/react-router"
import { getUserBusinessesQueryOptions } from "@/entities/business"

export const Route = createFileRoute("/(analytics)/")({
	component: Outlet,
	beforeLoad: ({ context }) => {
		if (context.auth.isAuthenticated) {
			context.queryClient.ensureQueryData(getUserBusinessesQueryOptions())
		}
	},
})
